module.exports = __webpack_public_path__ + "img/Diamond.53a9557.png";